function subtitle() {
    let articles = document.getElementsByTagName('h1');
    for (let index = 0; index < articles.length; index++) {
        if( index == 1 ) {
            document.getElementById('article-template__content_subtitle').innerHTML = articles[index].innerText;
            removeSubtitle();
        } 
    }
    removeLines();
}

function removeSubtitle() {
    let articles = document.getElementsByClassName('article-template__content');
    for (let index = 0; index < articles.length; index++) {
        let article = articles[index].children
        for (let articleIndex = 0; articleIndex < article.length; articleIndex++) {
           if ( articleIndex == 0) {
               let subtitle = article[articleIndex];
               subtitle.remove();
           }
        }
    }
}

function removeLines() {
    let subtitle = document.getElementById('article-template__content_subtitle');
    if( subtitle != null && subtitle.innerHTML == "") {
        document.getElementById("article-content-up").style.display = "none";
        document.getElementById("article-content-down").style.display = "none";
        document.getElementById("article-template__content_subtitle").style.display = "none";
    }
}